import(/* webpackMode: "eager" */ "/codebuild/output/src3993831471/src/web/app/global-error.tsx");
